module.exports = __webpack_public_path__ + "static/media/medal.51b912a4.svg";